import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi } from "@zeytal/types";

import { paintToSelectedFormat } from "../../../utils/colors.ts";

export const createSolidColor = (
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  paint: FigmaRestApi.SolidPaint,
) => paintToSelectedFormat(stylesFormatsConfig.colors, paint.color);
